import { render, staticRenderFns } from "./customer_sysuser.vue?vue&type=template&id=55d91936&scoped=true"
import script from "./customer_sysuser.vue?vue&type=script&lang=js"
export * from "./customer_sysuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d91936",
  null
  
)

export default component.exports